import { gettext } from '@eb/i18n-ebspa';

export const getLocationInfo = (venueName, venueAddress) => {
    //If we have both name and address add comma separated address
    if (venueAddress && venueName) {
        //ex. Eventbrite, San Francisco CA
        return gettext('%(venueName)s, %(venueAddress)s', {
            venueName,
            venueAddress,
        });
    }

    if (Boolean(!venueName) && Boolean(!venueAddress)) {
        return '';
    }

    return venueName || venueAddress;
};
